import { cEl } from '../../../../util';

function StepProgressIndicator({ progressStatus = [] }) {
    const stepProgressIndicator = cEl('span');
    stepProgressIndicator.classList.add('step-progress-indicator');
    const currentIndex = progressStatus.findLastIndex(active => active);
    stepProgressIndicator.append(
        ...progressStatus.map((active, i) => StepIndicator({ active, current: currentIndex === i })),
    );

    return stepProgressIndicator;
}

function StepIndicator({ active, current }) {
    const stepIndicator = cEl('div');
    stepIndicator.classList.add('step-indicator');
    if (active) {
        stepIndicator.classList.add('active');
    }
    if (current) {
        stepIndicator.classList.add('current');
    }
    return stepIndicator;
}

export default StepProgressIndicator;
